var xP = require('../../xP');

module.exports = {
  name: 'repeat_insert_button', base: 'button', prototype: {
    element_selector: '.repeat_insert_button',

    init: function (params) {
      xP.controls.repeat_insert_button.base.init.apply(this, arguments);

      var parent = this.parent(), repeat = parent.repeat;

      if (!(repeat instanceof xP.repeats.item)) {
        return;
      }

      this.$element.click(function () {
        repeat.append(parent, true);

        return false;
      });

      this.enabled = {
        on: function () {
          return repeat.val() < repeat.max
        }, from: repeat
      };
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/repeats/repeat_insert_button.js
 ** module id = 29
 ** module chunks = 0
 **/